import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconPlus: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M5.99992 11.1431H5.98773C5.51428 11.1431 5.13086 11.5265 5.13086 11.9999C5.13086 12.4743 5.51431 12.8568 5.98773 12.8568H6.00086H17.9989H18.0111C18.4846 12.8568 18.868 12.4734 18.868 11.9999C18.868 11.5256 18.4845 11.1431 18.0111 11.1431H17.998H5.99992Z"
        fill={fill}
      />
      <path
        d="M12.8568 5.99992V5.98773C12.8568 5.51428 12.4734 5.13086 11.9999 5.13086C11.5256 5.13086 11.1431 5.51431 11.1431 5.98773V6.00086V5.99992V17.999V18.0111C11.1431 18.4846 11.5265 18.868 11.9999 18.868C12.4743 18.868 12.8568 18.4846 12.8568 18.0111V17.998V17.999V5.99992Z"
        fill={fill}
      />
      <path
        d="M12 0C5.38322 0 0.000976562 5.3832 0.000976562 11.999C0.000976562 18.6158 5.38418 23.9981 12 23.9981C18.6168 23.9981 23.9991 18.6149 23.9991 11.999C23.9991 5.38224 18.6159 0 12 0ZM12 1.71468C17.6907 1.71468 22.2852 6.3102 22.2852 11.9999C22.2852 17.6905 17.6904 22.2851 12 22.2851C6.30962 22.2851 1.71482 17.6903 1.71482 11.9999C1.71482 6.30948 6.30962 1.71468 12 1.71468Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconPlus;
